import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { BehaviorSubject, Observable } from 'rxjs';

import { GraphService } from './graph.service';
import { SecurityService } from './security.service';
import { SsoSecurityService } from './sso-security.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardSsoService {

  valid:boolean =false;
  //public valid = new Promise<boolean>();
  constructor(private authService: SsoSecurityService,private msal:MsalService,private router:Router,private graphservice:GraphService,private userserive:UserService) { }

     async canActivate():Promise<boolean>{
 let unauthstate:boolean=this.userserive.getUnauthorizedState(); 
 if(unauthstate){
  this.userserive.resetUnauthorized();
  this.authService.logoutRedirect();
  this.authService.startAuthentication();
   
 }else  {
 let loginstate:boolean= this.userserive.getLoginState();
     //this.userserive.removeObject("oidc.user:https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/v2.0/:d7717f45-0094-4aee-b291-3ccc476eb633");
   let user=await this.authService.manager.getUser();
   if (user != null && !user.expired && loginstate) {
      
      return true;
    }
  

    if (this.authService.startAuthentication()) {
      return false;
    }
 
  }
  }

  refreshData() {
    let currentUrl = this.router.url;
   
  
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(currentUrl);
    })
   
  }
}
